module.exports = __webpack_public_path__ + "assets/images/banner/hero-banner-desktop.jpg?v=de294649";